import classnames from 'classnames';

import textClassSwitcher from '../../utils/textClassSwitcher';

import * as styles from '../Testimonials.css';
import type { TTestimonialAttributes } from '../Testimonials.types';

interface Props {
  name: string;
  className?: string;
  attributes?: TTestimonialAttributes;
}

const Name = ({ name, className = '', attributes }: Props) => {
  return (
    <span
      className={classnames(
        styles.testimonialsName,
        'font-semibold',
        textClassSwitcher(className, attributes?.nameFontSize || 'text-sm'),
      )}
    >
      {name}
    </span>
  );
};

export default Name;
